import React, { useEffect, useState } from 'react'
import { HttpStatus } from '@notino/react-toolkit/renderer/fragment/contexts/HttpContext'

// components
import PageErrorView from '../PageErrorView/PageErrorView'

// types
import { ContextProps } from '../../types/types'

// utils
import { ERROR_PAGE_CODE } from '../../utils/enums'

type FragmentStatusProps = {
	statusCode: ERROR_PAGE_CODE
	onRetry?: () => void
	isRetrying?: boolean
	minHeight?: string
} & ContextProps

/** SSR: signals status to the Notino layout via HttpStatus. Client: renders PageErrorView in the fragment. */
const FragmentStatus = ({ statusCode, onRetry, isRetrying, minHeight, ...contextProps }: FragmentStatusProps) => {
	const [isClient, setIsClient] = useState(false)

	useEffect(() => {
		setIsClient(true)
	}, [])

	if (!isClient) {
		return (
			<HttpStatus status={statusCode} {...contextProps}>
				{null}
			</HttpStatus>
		)
	}

	return <PageErrorView statusCode={statusCode} onRetry={onRetry} isRetrying={isRetrying} minHeight={minHeight} />
}

export default FragmentStatus
